module.exports = __webpack_public_path__ + "img/gls_gbt31_2_1988.prt.3ffd62aa.jpg";